import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';

import { DeprecatedGrid as Grid, buttonCSS } from '@simplywallst/ui-core';

import type { ButtonProps } from '@simplywallst/ui-core';

export const ExtraWrapper = styled(Grid)`
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  padding-left: ${({ theme }) => theme.x2spacePx}px;
  padding-top: ${({ theme }) => theme.x1spacePx}px;
  margin-bottom: ${({ theme }) => theme.x3spacePx}px;
  > a {
    min-width: ${({ theme }) => theme.x4spacePx}px;
    border-radius: ${({ theme }) => theme.x2spacePx + 2}px;
    border: 1px solid ${({ theme }) => theme.color.spaceGrayRGBA(0.2)};
    margin-right: ${({ theme }) => theme.x1spacePx / 2}px;
  }
  span {
    color: ${({ theme }) => theme.color.spaceGray};
    ${({ theme }) => theme.typography.xSmall};
  }
  > span {
    color: ${({ theme }) => theme.color.spaceGrayRGBA(0.7)};
    padding: ${({ theme }) => theme.x1spacePx}px;
  }
`;

export const Link = styled(RouterLink)<ButtonProps>`
  ${buttonCSS}
`;
